import { render } from "./AppUserAccess.vue?vue&type=template&id=a6f517f0&ts=true"
import script from "./AppUserAccess.vue?vue&type=script&lang=ts"
export * from "./AppUserAccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__